import React, { useState } from "react";
import { Box, Menu, MenuItem } from "@mui/material";
import { tokens } from "../../theme";
import { IconChevronDown, IconClients } from "../ui/icons";

/** Filtro de operador. Vive al lado del buscador, con el mismo aspecto que los chips. */
const OperatorFilter = ({ employees = [], value, onChange }) => {
  const [anchor, setAnchor] = useState(null);
  const selected = employees.find((e) => e.employeeId === value);
  const active = Boolean(value);

  return (
    <>
      <Box
        onClick={(e) => setAnchor(e.currentTarget)}
        role="button"
        aria-label="Filtrar por operador"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "7px",
          minHeight: { xs: 44, md: 36 },
          padding: "0 12px",
          borderRadius: `${tokens.radiusControl}px`,
          fontSize: "13px",
          whiteSpace: "nowrap",
          cursor: "pointer",
          flexShrink: 0,
          border: `1px solid ${active ? tokens.graphite : tokens.border}`,
          backgroundColor: active ? tokens.graphite : tokens.surface,
          color: active ? "#fff" : tokens.ink2,
          fontWeight: active ? 500 : 400,
        }}
      >
        <IconClients size={15} />
        {selected ? `${selected.name || ""} ${selected.lastName || ""}`.trim() : "Operador"}
        <IconChevronDown size={14} />
      </Box>

      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        <MenuItem
          onClick={() => {
            onChange(null);
            setAnchor(null);
          }}
          sx={{ fontSize: "13.5px" }}
        >
          Todos los operadores
        </MenuItem>
        {employees.map((emp) => (
          <MenuItem
            key={emp.employeeId}
            selected={emp.employeeId === value}
            onClick={() => {
              onChange(emp.employeeId);
              setAnchor(null);
            }}
            sx={{ fontSize: "13.5px" }}
          >
            {`${emp.name || ""} ${emp.lastName || ""}`.trim()}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default OperatorFilter;
